import React, { Fragment } from 'react';
import { array, func, bool, object } from 'prop-types';
import { FormHelperText, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

class CategoryLocationsAutocompletion extends React.Component {
  static getDerivedStateFromProps(props) {
    const { subcategories } = props;
    const locations = {};
    let i = 0;
    subcategories.forEach(sub => {
      (sub.locations || []).forEach(location => {
        locations[i++] = { location, sub: sub.name };
      });
    });

    return { locations };
  }

  constructor(props) {
    super(props);
    this.state = { location: {} };
  }

  render() {
    const { locations } = this.state;
    const { onLocationSelected, meta } = this.props;
    const { error } = meta;
    const options = Object
      .keys(locations)
      .map(locId => ({ value: locId, label: locations[locId].location }));
    return (
      <Fragment>
        <Autocomplete
          getOptionLabel={option => option.label}
          onChange={(_, value) => onLocationSelected(value ? locations[value.value].sub : null)}
          options={options}
          renderInput={params => <TextField {...params} placeholder="Wybierz lokalizację" variant="standard" />}
        />
        {error && <FormHelperText error>{error}</FormHelperText>}
      </Fragment>
    );
  }
}

CategoryLocationsAutocompletion.propTypes = {
  subcategories: array.isRequired,
  onLocationSelected: func.isRequired,
  touched: bool.isRequired,
  meta: object.isRequired,
};

export default CategoryLocationsAutocompletion;



// WEBPACK FOOTER //
// ./src/components/budget/CategoryLocationsAutocompletion.js